export const cloneDate = (date: Date) => new Date(date.getTime());
